import { render, staticRenderFns } from "./OrderItem.vue?vue&type=template&id=85a1efdc"
import script from "./OrderItem.vue?vue&type=script&lang=ts"
export * from "./OrderItem.vue?vue&type=script&lang=ts"
import style0 from "./OrderItem.vue?vue&type=style&index=0&id=85a1efdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports